import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ControlContainer,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { ServiceDataFields } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/service-data-fields.enum';
import { InVitroTypes } from '@app/modules/service-data/types/service-data.types';
import { TranslateModule } from '@ngx-translate/core';
import { SelectOptionComponent } from '@shared/components/select/select-option/select-option.component';
import { SelectComponent } from '@shared/components/select/select.component';
import { ValidationErrorComponent } from '@shared/components/validation-error/validation-error.component';
import { InputValidationStatusDirective } from '@shared/directives/input-validation-status.directive';
import { controlContainerProvider } from '@shared/helpers';

@Component({
  selector: 'app-service-data-form-in-vitro',
  imports: [
    TranslateModule,
    ValidationErrorComponent,
    ReactiveFormsModule,
    InputValidationStatusDirective,
    SelectComponent,
    SelectOptionComponent,
  ],
  templateUrl: './service-data-form-in-vitro.component.html',
  viewProviders: [controlContainerProvider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDataFormInVitroComponent implements OnInit {
  private controlContainer = inject(ControlContainer);

  @Input({ required: true }) fieldSet: string[];
  protected get form() {
    return this.controlContainer.control as FormGroup;
  }

  protected readonly Object = Object;
  protected readonly InVitroTypes = InVitroTypes;

  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.form
      .get('inVitro.isInVitroFertilized')
      .valueChanges.pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((inVitro: boolean) => {
        if (!inVitro) {
          this.form.get('inVitro.vitroType').reset(null);
          this.form.get('inVitro.isSurrogateMother').reset(null);
        }
      });
  }

  protected readonly ServiceDataFields = ServiceDataFields;
}
